import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { LostFoundService } from '../lost-found.service';
import { LostFound } from '../lost-found';
import { LostFoundComponent } from '../lost-found/lost-found.component';

@Component({
    selector: 'app-lostFound-list',
    templateUrl: './lost-found-list.component.html',
    styleUrls: ['./lost-found-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class LostFoundListComponent implements OnInit {
	constructor(
		private lostFoundService: LostFoundService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = lostFoundService.statuses
	}



	// data
	@Input() reservationId: any;
	@Input() showFilter: boolean = true;
	@Input() showPagination: boolean = true;
	lostFounds: any;
	lostFound: LostFound;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;
	showPaginator = false;

	statuses: any;

	columns: any[] = [];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
		this.setupColumns();
	}

	setupColumns() {
		this.columns = [
			{ field: 'shortTermRentalId', header: 'ShortTermRentalId', width: 'auto', condition: !this.reservationId },
			{ field: 'propertyCode', header: 'Property', width: 'auto', condition: true },
			{ field: 'reservationId', header: 'ReservationId', width: 'auto', condition: !this.reservationId },
			{ field: 'guestLastName', header: 'Name ', width: 'auto', condition: true },
			{ field: 'itemName', header: 'Item Name', width: 'auto', condition: true },
			{ field: 'itemDesc', header: 'Item Description', width: 'auto', condition: !this.reservationId },
			{ field: 'status', header: 'Status', width: 'auto', condition: true },
			{ field: 'guestInquired', header: 'Guest Inquired', width: 'auto', condition: !this.reservationId },
			{ field: 'guestNotified', header: 'Guest Notified', width: 'auto', condition: !this.reservationId },
			{ field: 'itemReturned', header: 'Item Returned', width: 'auto', condition: !this.reservationId },
			{ field: 'returnDate', header: 'Return Date', width: 'auto', condition: true },
		];
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.lostFoundId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent, isLoading: any) {
		try {
			if(!isLoading){
				this.loading = true;
			}
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-lostFound-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			if (this.reservationId) {
				// show only reservations that are assigned to this reservationId
				let reservationIdFilter = { 'reservationVO.reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
				Object.assign(event.filters, reservationIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.lostFoundService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.lostFounds = res.data.lostFounds;
						if(this.lostFounds.length < event.rows){
							this.showPaginator = false;
						}else{
							this.showPaginator = true;
						}
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.lostFounds = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(lostFound: LostFound) {
		try {
			this.formLoading = true;
			this.lostFoundService.update(lostFound)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.lostFounds.map((lostFound, i) => {
							if (lostFound.lostFoundId === res.data.lostFound.lostFoundId) {
								this.lostFounds[i] = res.data.lostFound;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(lostFound: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(lostFound));

			this.formLoading = true;
			this.lostFoundService.delete(lostFound.lostFoundId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.lostFounds.splice(this.lostFounds.indexOf(lostFound), 1);
						this.recordTotal = this.lostFounds.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'LostFound ' + lostFound.lostFoundId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'LostFound ' + lostFound.lostFoundId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = '90%';

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Lost Found',
			reservationId: this.reservationId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(LostFoundComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addLostFoundCB(data);
				
				this.loadLazy(this.lazyLoadEvent, true);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(lostFound: LostFound) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = '90%';
		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			lostFound: lostFound,
			title: 'Edit Lost Found'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(LostFoundComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateLostFoundCB(data);
				
				this.loadLazy(this.lazyLoadEvent, true);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteLostFoundCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addLostFoundCB(lostFound: LostFound) {
		console.log('Adding LostFound: ' + JSON.stringify(lostFound));
		// if we don't have a lostFounds array yet...
		if (!this.lostFounds) {
			this.lostFounds = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.lostFounds.unshift(lostFound);

		// no idea what this is but it is required to update the array
		this.lostFounds = [...this.lostFounds];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'LostFound ' + lostFound.lostFoundId + ' Added', life: 3000 });
	}

	updateLostFoundCB(lostFound: LostFound) {
		console.log('Updating LostFound: ' + JSON.stringify(lostFound));
		let itemIndex = this.lostFounds.findIndex((item: any) => item.lostFoundId === lostFound.lostFoundId);
		this.lostFounds[itemIndex] = lostFound;

		// no idea what this is but it is required to update the array
		this.lostFounds = [...this.lostFounds];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'LostFound ' + lostFound.lostFoundId + ' Updated', life: 3000 });
	}

	deleteLostFoundCB(lostFound: LostFound) {
		console.log('Removing LostFound: ' + lostFound);
		this.lostFounds.splice(this.lostFounds.indexOf(lostFound), 1);
		this.recordTotal = this.lostFounds.length;

		// no idea what this is but it is required to update the array
		this.lostFounds = [...this.lostFounds];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'LostFound ' + lostFound.lostFoundId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.lostFounds ? this.first === (this.lostFounds.length - this.rows) : true; }
	isFirstPage(): boolean { return this.lostFounds ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(lostFound: any) {
		if (lostFound?.status) {
			const status = this.statuses.find((e: any) => e.value == lostFound.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
